var processInclude = require("base/util");

if ($("#cbt-site-location").length) {
    processInclude(require("cbt/components/cbtStorePage"));
    processInclude(require("cbt/components/cbtBanner"));
}

$(document).ready(function () {
    processInclude(require("./components/RnContentTilesCarousel"));
    processInclude(require("./components/tabCarousel"));
    processInclude(require("./layout.js"));
});

require("coremh/thirdParty/css3-animate-it.min");
